import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import Restaurant from "@/components/hotel/Restaurant";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const RestaurantPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Restaurant & Frühstück"
        description="Geniessen Sie Frühstück, Grillspezialitäten und saisonale Küche im Restaurant des ESOS Hotel Quelle in Bad Ragaz."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Restaurant", path: "/restaurant" },
        ]}
        jsonLd={[{
          "@context": "https://schema.org",
          "@type": "Restaurant",
          name: "Restaurant ESOS Hotel Quelle",
          image: "https://storage.googleapis.com/gpt-engineer-file-uploads/LWmdENiduXdTolLj05Xw2KcFswk2/social-images/social-1774369533197-WhatsApp_Image_2026-03-24_at_15.26.52.webp",
          servesCuisine: ["Schweizerisch", "Saisonal", "Grill"],
          address: {
            "@type": "PostalAddress",
            streetAddress: "Badstrasse 9a",
            addressLocality: "Bad Ragaz",
            postalCode: "7310",
            addressRegion: "St. Gallen",
            addressCountry: "CH",
          },
          telephone: "+41 81 302 11 13",
          url: "https://esoshotelquelle.com/restaurant",
          openingHoursSpecification: [
            { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], opens: "07:00", closes: "10:00", description: "Frühstück" },
          ],
        }]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.restaurant.title} subtitle={t.subpageHeroes.restaurant.subtitle} />
      <Restaurant />
      <Footer />
    </main>
  );
};

export default RestaurantPage;
